"use client";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import RightArrow from "@/icons/RightArrow";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { data } from "@/lib/carrier";
import { usePathname } from "next/navigation";
import React from "react";

// Job Data
// const data = [
//   { title: "Customer Service Specialist", id: "1" },
//   { title: "Sales Associate, Appliances- commissioned (San Rafael)", id: "2" },
//   { title: "STORE MANAGER - DUBLIN", id: "3" },
//   { title: "Sales Associate, Appliances- commissioned (Roseville)", id: "4" },
//   { title: "Retail Store Lead", id: "5" },
//   { title: "Store Manager - Roseville", id: "6" },
//   { title: "Sales Associate", id: "7" },
//   {
//     title: "Sales Associate, Appliances - commissioned (Redwood City)",
//     id: "8",
//   },
// ];

const DynamicBreadcrumb = ({
  sku,
  formattedLinks,
  className,
  onBreadCrumbClick = () => {},
}) => {
  const pathname = usePathname();

  // Split the pathname into segments
  let pathSegments = pathname.split("/").filter(Boolean);
  if (pathSegments.includes("index") && pathSegments.includes("detail")) {
    pathSegments = pathSegments.filter(
      (segment) =>
        segment !== "index" && segment !== "detail" && segment !== "id"
    );
  }

  // Check if the last segment is an ID and replace it with the corresponding title
  const lastSegment = pathSegments[pathSegments.length - 1];
  const job = data.find((item) => item.id === lastSegment);

  if (job) {
    pathSegments[pathSegments.length - 1] = job.title; // Replace ID with title
  }

  const modifiedValues = {
    "All Refrigerators": "Refrigeration",
    Laundry: "Washers & Dryers",
    "Stacked Washer Dryer Sets": "Laundry Centers",
    "Grills Outdoor Kitchens": "Outdoor Grills",
    "Builder Trade": "Builders & Trade",
    "Delivery And Installation": "Delivery & Installation",
    Trade: "Builders & Trade",
    Shop: "Search Results",
    "Smart Dishwashers2": "Smart Dishwashers",
    "Gaggenau Combi Microwave Oven Demo Redwood": "Gaggenau Combi Microwave Oven Demo San Jose",
    "New Concord Store Grand Opening":"Concord Showroom Grand Opening"
  };
  // Generate breadcrumb items based on the path segments
  const breadcrumbItems = pathSegments.map((segment, index) => {
    let href = `/${pathSegments.slice(0, index + 1).join("/")}`;
    // Replace hyphens with spaces and capitalize each word
    if (segment.toLowerCase() === "all-brands") {
      href = "/brands";
    }

    const label = decodeURIComponent(segment)
      .replace(/[“”]/g, '"')
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
      .replace(/%20/g, " ");

    return {
      href,
      label,
    };
  });

  const finalItems = [
    { href: "/", label: "Home" },
    ...(formattedLinks || []),
    ...(sku
      ? [{ href: pathname, label: "Model: " + sku.toUpperCase() }]
      : breadcrumbItems),
  ];

  const breadcrumbRedirects = {
    "/blog/post": "/blog",
    "/blog/category": "/blog",
    "/blog/tag": "/blog",
    "/blog/archive": "/blog",
  };

  return (
    <div
      className={cn(
        "px-5 container max-w-1440 py-5 lg:bg-mobileBG lg:p-[14px]",
        className
      )}
    >
      <Breadcrumb>
        <BreadcrumbList className="font-light text-[13px] leading-[20px] gap-[1px]">
          {finalItems.map((item, index) => (
            <React.Fragment key={item.href}>
              <BreadcrumbItem>
                {index !== finalItems.length - 1 ? (
                  <Link
                    href={breadcrumbRedirects[item.href] || item.href}
                    onClick={() => onBreadCrumbClick(index)}
                  >
                    {modifiedValues[item.label] || item.label}
                  </Link>
                ) : (
                  <BreadcrumbPage className="text-gray8 font-medium md:truncate md:max-w-72">
                    {modifiedValues[item.label] || item.label}
                  </BreadcrumbPage>
                )}
              </BreadcrumbItem>
              {index < finalItems.length - 1 && (
                <BreadcrumbSeparator className="[&>svg]:size-2.5 px-1">
                  <RightArrow />
                </BreadcrumbSeparator>
              )}
            </React.Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default DynamicBreadcrumb;
